import { RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import * as router from './router';
import * as settings from './settings';

export interface AppState {
    settings: settings.SettingsState;
    router: RouterReducerState<router.RouterStateUrl>;
}

export const reducers: ActionReducerMap<AppState> = {
    settings: settings.reducer,
    router: router.reducer,
};

export const metaReducers: MetaReducer<AppState>[] = [settings.settingsMetaReducer].concat([]);
